import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import "./header.css";

function Logo(props) {
  return (
    <svg
      width={115.723}
      height={68.508}
      viewBox="0 0 115.723 68.508"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M55.142 35.309c-2.89-1.644-5.61-3.232-8.502-3.572C40.067 31 33.153 37.235 29.98 44.09c-1.02 2.267-1.643 4.59-1.643 6.688-.056 1.927.396 3.684 1.529 5.044 1.87 2.268 5.61 3.627 11.903 3.116 3.512-.282 5.835-.453 8.329-.678h.566c2.947-.227 6.687-.17 10.711-.114 8.728.17 18.76.339 24.143-2.437.964-.455 1.53-1.247 1.757-2.21.284-1.02.17-2.266-.284-3.57a12.217 12.217 0 00-2.437-4.081c-1.87-2.096-4.42-3.798-7.536-4.364-1.815-.396-3.798-.622-5.95-.907-1.532-.227-3.174-.453-4.705-.68-4.42-.679-7.933-2.719-11.221-4.59zm32.302 29.695c-5.78 2.946-16.093 2.775-25.106 2.606-3.91-.056-7.594-.114-10.484.113h-.566c-3.06.227-6.007.456-8.33.683-7.197.565-11.788-1.25-14.227-4.252-1.698-2.04-2.434-4.535-2.378-7.255 0-2.72-.624-4.306-.567-6.63 0-2.55.737-5.212 1.927-7.82 3.457-7.538 11.165-14.338 18.7-13.488 3.458.396 6.405 2.097 9.52 3.91 3.12 1.758 6.406 3.628 10.317 4.25 1.642.228 3.173.453 4.702.68 2.098.284 4.138.509 6.066.908 3.738.736 6.913 2.776 9.18 5.326 1.417 1.644 2.946 3.57 3.57 5.328.34 1.019.396 2.38.396 3.683.114 4.761-2.436 6.29-6.346 7.65 0 0 5.044 0 6.857-.905.17 2.323-.283 3.683-3.23 5.213"
        fill="#ed1d24"
        fillRule="evenodd"
      />
      <path
        d="M41.087 55.54c3.287.567 6.517-.398 5.214-2.097-3.116-4.136-8.783-13.488-11.958-10.03-3.173 3.398-2.097 7.478-1.018 9.293 1.472 2.436 4.02 2.153 7.762 2.835m-1.302-16.266c.906-2.04 3.285-2.72 3.285-2.72l5.101 3.683s-1.813-4.308-1.417-4.93c.453-.68 6.234 2.55 8.33 3.345 2.04.736-1.529 6.06-1.529 6.06s.963.23 2.097-.904c1.19-1.134 2.494-3.628 2.89-3.628.737 0 4.76 2.549 10.372 3.345 5.666.792 10.54.283 11.673 1.132 1.19.908.793.568.113 1.53-.736.965-2.889 2.607-2.889 2.607s4.477-.622 5.383-.056c.566.339-.056 3.798-1.87 4.307-4.024 1.077-13.6 1.587-17.852 1.36 0 0-.396-4.872-.737-4.816-.339 0-1.87 4.704-3.06 4.59-6.8-.68-9.973 2.606-12.58-2.663-1.417-2.948-8.217-10.26-7.31-12.242"
        fill="#ed1d24"
        fillRule="evenodd"
      />
      <path
        d="M29.583 58.543c2.04 4.817 17.397 2.89 21.421 2.72-5.383 1.19-17.114 6.064-21.42-2.72"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M110.114 42.449l2.266-1.02-.397-1.022-2.267.85c.058.172.058.285.114.454.057.227.17.454.284.738zm-17.568 7.65l13.43-5.893c-.057-.115-.057-.284-.057-.453a2.653 2.653 0 01-.17-.964l-13.94 5.213zm-3.684-35.364l1.813-3.456-.85-.624-2.04 3.402c.34.226.793.396 1.077.678zM78.208 35.534l8.103-15.98c-.51-.285-.793-.399-1.247-.795l-8.613 15.527zm18.418-4.987l6.913-6.29-.68-.851-7.141 5.837c.284.454.568.908.906 1.304zm-9.748 8.446l6.517-5.555c-.34-.51-.68-.907-1.02-1.475l-6.915 5.499c.227.283.398.623.682.905.282.23.51.399.736.626zM57.862 15.757L58.372 0l1.02.057.056 16.379c-.453-.114-.68-.398-1.189-.567a1.036 1.036 0 00-.397-.113zm-.454 14.508l.227-7.935c.567.056 1.247 0 1.87 0v9.067zm15.134-16.662l2.492-10.597-1.02-.284-2.834 10.257c.171.112.34.34.51.34l.51.171c.112 0 .226.056.34.113zm-4.934 20.514l3.912-16.094-.057-.056c-.453 0-.85-.17-1.19-.397-.114 0-.227-.056-.283-.056l-4.42 15.98zm-24.48-21.591l-2.438-9.52 1.021-.284 2.89 9.408c-.567 0-.964.056-1.474.396zm3.117 12.41l-1.587-6.233c.567-.284.963-.622 1.417-1.076l.17-.057 2.04 6.688zm-18.93-9.805L25.05 11.28l.906-.624 2.382 3.628c-.398.227-.68.51-1.022.848zm7.424 12.412l-5.213-8.784c.284-.056.51-.226.737-.51.17-.168.283-.168.454-.282l5.497 8.274c1.473 2.21.17 4.137-1.475 1.302zM15.7 27.43l-3.514-3.172.68-.852 3.57 2.948c-.226.397-.51.68-.737 1.076zm3.23 2.948c.113-.17.17-.399.284-.568.226-.283.396-.396.566-.736 11.05 9.01 9.69 10.768-.85 1.304zM6.46 61.772L0 61.32l.113-1.132 6.745.114a13.884 13.884 0 00-.398 1.471zm9.633.624V60.47c7.71.113 7.88 2.493 0 1.926zm.285-15.3L3.345 41.43l.397-1.022 12.976 4.876c-.113.452-.227.962-.227 1.415zm4.307 1.869v-.452c0 .282.113-.794.113-.85.114-.226.17-.624.227-.796 4.307 1.646 3.57 3.799-.34 2.098zm89.144 12.751l5.893-.397-.056-1.132-5.837.114zm-15.528 1.078L105.579 62v-1.643l-11.333.226.056 2.21"
        fill="#de707f"
      />
    </svg>
  );
}

function Hamburger(props) {
  return (
    <svg
      width={704.215}
      height={436.093}
      viewBox="0 0 704.215 436.093"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.189 204.766h339.867l110.571 61.832 110.568-61.832h108.837c9.45 0 17.18 7.74 17.18 17.192v64.16c0 9.452-7.73 17.179-17.18 17.179H17.19c-9.456 0-17.19-7.727-17.19-17.179v-64.16c0-9.452 7.734-17.192 17.19-17.192"
        fill="#9a3e3c"
        fillRule="evenodd"
      />
      <path
        d="M704.212 352.882v27.417c0 30.728-25.068 55.795-55.801 55.795H55.798c-30.732 0-55.799-25.067-55.799-55.795v-27.417c0-7.693 6.268-13.95 13.955-13.95h676.309c7.68 0 13.95 6.257 13.95 13.95zM139.496 4.648H564.72c76.827 0 139.493 62.665 139.493 139.485v11.062c0 7.693-6.27 13.947-13.95 13.947H13.955c-7.687 0-13.955-6.254-13.955-13.947v-11.062C0 67.313 62.664 4.648 139.496 4.648"
        fill="#d85a1d"
        fillRule="evenodd"
      />
      <path
        d="M197.984 3.758c-8.573-4.223-18.057-4.611-27.293-2.522-1.73.388-2.984 1.392-3.765 2.967-.783 1.597-.806 3.207-.058 4.807 3.978 8.606 10.05 15.865 18.628 20.1 8.572 4.211 18.063 4.611 27.287 2.522 1.734-.4 2.99-1.392 3.778-2.98.782-1.585.804-3.194.063-4.805-3.972-8.595-10.05-15.865-18.64-20.09zM307.705 23.79c-8.584 4.235-14.661 11.494-18.638 20.1-.743 1.597-.72 3.206.06 4.794.782 1.6 2.045 2.592 3.774 2.98 9.228 2.088 18.715 1.7 27.287-2.524 8.582-4.222 14.661-11.482 18.638-20.089.743-1.597.72-3.206-.062-4.793-.776-1.599-2.038-2.603-3.76-2.99-9.236-2.089-18.72-1.691-27.299 2.522zM107.176 58.24c-8.584 4.222-14.657 11.494-18.64 20.087-.742 1.61-.72 3.22.068 4.805.782 1.588 2.043 2.592 3.768 2.98 9.234 2.09 18.719 1.702 27.284-2.522 8.584-4.223 14.663-11.483 18.636-20.09.747-1.598.736-3.218-.057-4.793-.776-1.599-2.037-2.604-3.756-2.992-9.233-2.09-18.73-1.701-27.303 2.524zm99.647 35.668C198.24 98.144 192.16 105.404 188.19 114c-.742 1.61-.724 3.23.057 4.816.782 1.587 2.05 2.58 3.772 2.98 9.23 2.088 18.72 1.69 27.286-2.524 8.584-4.235 14.663-11.495 18.635-20.1.747-1.599.725-3.208-.05-4.795-.783-1.586-2.043-2.59-3.767-2.978-9.235-2.088-18.722-1.7-27.3 2.51zM472.65 2.651c-9.57 0-18.222 3.835-25.602 9.793-1.376 1.119-2.06 2.58-2.06 4.35s.684 3.22 2.065 4.337c7.375 5.959 16.026 9.782 25.597 9.782 9.565 0 18.23-3.823 25.592-9.782 1.375-1.117 2.072-2.568 2.072-4.337 0-1.77-.697-3.231-2.065-4.35-7.37-5.958-16.034-9.793-25.599-9.793zm105.227 44.345c-7.855-5.433-17.198-7.213-26.627-6.507-1.763.127-3.161.938-4.159 2.386-1.012 1.461-1.262 3.05-.77 4.75 2.669 9.084 7.606 17.178 15.477 22.611 7.853 5.433 17.19 7.213 26.624 6.507 1.757-.138 3.161-.936 4.166-2.386 1.006-1.45 1.267-3.048.771-4.749-2.67-9.085-7.608-17.179-15.482-22.612zM500.5 97.29c-6.306-7.192-14.907-11.176-24.238-12.785-1.746-.308-3.293.125-4.622 1.301-1.324 1.154-1.976 2.66-1.895 4.418.376 9.462 3.201 18.502 9.508 25.693 6.3 7.192 14.89 11.187 24.233 12.797 1.74.298 3.287-.138 4.628-1.302 1.314-1.152 1.964-2.66 1.895-4.418-.383-9.462-3.195-18.513-9.51-25.704zM388.977 50.615c-9.565 0-18.224 3.834-25.597 9.805-1.376 1.107-2.067 2.567-2.067 4.337 0 1.758.696 3.22 2.079 4.338 7.361 5.946 16.02 9.781 25.585 9.781 9.57 0 18.23-3.835 25.603-9.781 1.374-1.119 2.065-2.58 2.065-4.338 0-1.77-.69-3.23-2.065-4.337-7.368-5.97-16.027-9.805-25.603-9.805"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

function Cross(props) {
  return (
    <svg
      width={537.713}
      height={537.714}
      viewBox="0 0 537.713 537.713"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M502.029 4.079l19.386 19.387c21.728 21.728 21.728 57.178-.005 78.91l-419.039 419.04c-21.732 21.732-57.181 21.732-78.909.003L4.075 502.032c-5.44-5.44-5.432-14.296.004-19.73L482.302 4.079c5.43-5.43 14.287-5.44 19.727 0z"
        fill="#d85a1d"
        fillRule="evenodd"
      />
      <path
        d="M35.68 4.079L16.295 23.466c-21.728 21.728-21.727 57.178.005 78.91l419.04 419.04c21.731 21.732 57.18 21.732 78.908.003l19.387-19.387c5.44-5.44 5.432-14.296-.004-19.73L55.407 4.079c-5.43-5.43-14.286-5.44-19.726 0z"
        fill="#d85a1d"
        fillRule="evenodd"
      />
    </svg>
  );
}

function Decore(props) {
  return (
    <svg
      width={30.266}
      height={16.969}
      viewBox="-4 0 16.008 4.49"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.888 3.08q-.545.236-.963.236-.388 0-.657-.256-.269-.257-.269-.625 0-.442.319-.736.318-.293.797-.293.711 0 1.542.798.38-.273.86-.77l.207-.214Q4.902 0 5.791 0q.389 0 .583.137.198.136.198.409 0 .537-.797.649.062-.132.062-.21 0-.162-.1-.24-.095-.08-.285-.08-.53 0-1.443.873l-.21.203q.826-.298 1.591-.298 1.058 0 1.836.521.781.52.781 1.232 0 .45-.418.715-.417.265-1.124.265.22-.26.22-.653 0-.666-.547-1.104-.541-.438-1.364-.438-.785 0-1.807.5l.298.306q1.046 1.07 1.451 1.07.186 0 .281-.086.095-.091.095-.265 0-.198-.194-.343-.19-.145-.455-.145-.128 0-.306.062.294-.628.745-.628.301 0 .52.235.224.232.224.546 0 .525-.414.893-.413.364-1.004.364-.947 0-2.047-1.129zm-.322-.322q-.488-.447-.703-.447-.136 0-.206.062-.067.058-.067.178 0 .161.108.244.107.078.326.078.249 0 .542-.115z"
        fill="#5e5c64"
      />
    </svg>
  );
}

function NavMenu() {
  return (
    <nav>
      <Link to="/">Menu</Link>
      <Decore />
      <Link to="/about-me/">About Me</Link>
      <span className="spacer" />
      <Link to="/rss.xml">RSS</Link>
      <Decore style={{ transform: "scale(-1,1)" }} />
      <a href="https://twitter.com/nkrkv_" target="_blank" rel="noreferrer">
        Twitter
      </a>
      <Decore style={{ transform: "scale(-1,1)" }} />
      <a href="https://github.com/nkrkv/" target="_blank" rel="noreferrer">
        GitHub
      </a>
    </nav>
  );
}

function Header({ siteTitle }) {
  const [isMenuOpen, updateMenuOpen] = React.useState(false);
  return (
    <>
      <header className={isMenuOpen ? "menu-open" : "menu-closed"}>
        <button
          className="hamburger-button"
          onClick={() => updateMenuOpen(x => !x)}
        >
          <div className="hamburger-button__body">
            {isMenuOpen ? (
              <Cross width={32} height={32} preserveAspectRatio="xMidYMid" />
            ) : (
              <Hamburger
                width={44}
                height={44}
                preserveAspectRatio="xMidYMid"
              />
            )}
          </div>
        </button>
        <NavMenu />
        <div className="body">
          <Link to="/">
            <div style={{ marginBottom: `2rem` }}>
              <Logo
                width={420}
                height={249}
                preserveAspectRatio="xMidYMax"
                style={{ maxWidth: "100%" }}
              />
            </div>
            <span className="title">FULL STEAK DEV</span>
            <span className="author">by VICTOR NAKORIAKOV</span>
          </Link>
        </div>
        <div className="line1" />
        <div className="line2" />
      </header>
    </>
  );
}

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
